import React, {useEffect, useState} from 'react';

import {
  BrandContainer,
  BrandImage,
  Container,
  Date,
  Description,
  DetailItem,
  DetailsButton,
  DetailsButtonIcon,
  DetailsButtonText,
  Icon,
  Infos,
  LeftContent,
  Payment,
  PaymentMethodInfo,
  PaymentTitle,
  Subtitle,
  Title,
  Value,
  ValueBig,
} from './styles';

import {RFValue} from 'react-native-responsive-fontsize';
import {useTheme} from 'styled-components/native';

interface Props {
  data: {
    checked?: boolean;
    action?: () => void;
    date: string;
    identificador: string;
    formaPagamento: 'PIX' | 'CCT';
    installments: number;
    valorTotal: string;
    index?: number;
    produto: string;
    quantidadeCupons: number;
    quantidadeCuponsUsados: number;
    valorReembolos: string;
    justificativaDesconto: string;
  };
}

export function ReembolsoItem({data}: Props) {
  const [showItems, setShowItems] = useState(false);
  const theme = useTheme();

  const quantidade = data.quantidadeCupons;
  const usados = data.quantidadeCuponsUsados;

  const utilizadoSpan =
    usados > 0
      ? usados > 1
        ? usados + ' de ' + quantidade + ' cupom foi utilizado'
        : usados + ' de ' + quantidade + ' cupons foram utilizados.'
      : 'Nenhum cupom foi utilizado';

  return (
    <Container
      checked={data.checked}
      activeOpacity={1}
      onPress={data.action}
      underlayColor={theme.colors.button_click_bg}
      disabled={!data.action}
      style={{
        backgroundColor: !data.checked
          ? theme.colors.background
          : theme.colors.blue_opacity,
        borderTopWidth: data.index === 0 && !data.action ? 1 : 0,
      }}>
      <LeftContent>
        {!!data.action && (
          <Icon
            name={!data.checked ? 'circle-o' : 'check-circle'}
            checked={data.checked}
          />
        )}

        <Infos style={{marginLeft: data.action ? RFValue(12) : 0}}>
          {data.formaPagamento === 'PIX' ? (
            <Payment>
              <BrandContainer>
                <BrandImage
                  source={{
                    uri: 'https://d3ag5cip9ldvh3.cloudfront.net/card_brands/pix.png',
                  }}
                />
              </BrandContainer>
              <PaymentMethodInfo>
                <PaymentTitle>PIX</PaymentTitle>
              </PaymentMethodInfo>
            </Payment>
          ) : (
            <Payment>
              <BrandContainer>
                <BrandImage
                  source={{
                    uri: 'https://d3ag5cip9ldvh3.cloudfront.net/card_brands/creditcard_blank.png',
                  }}
                />
              </BrandContainer>
              <PaymentMethodInfo>
                <PaymentTitle>
                  {data.valorTotal} em {data.installments}x
                </PaymentTitle>
              </PaymentMethodInfo>
            </Payment>
          )}

          <Date>{data.date}</Date>

          <Value>
            Disponível: <ValueBig>{data.valorReembolos}</ValueBig>
          </Value>

          {data.justificativaDesconto && (
            <Description>{data.justificativaDesconto}</Description>
          )}

          <DetailsButton
            activeOpacity={0.7}
            onPress={() => setShowItems(!showItems)}>
            <DetailsButtonText>
              {showItems ? 'Ocultar' : 'Exibir'} itens da compra (
              {data.quantidadeCupons})
            </DetailsButtonText>
            <DetailsButtonIcon
              name={showItems ? 'chevron-up' : 'chevron-down'}
            />
          </DetailsButton>

          {showItems && (
            <DetailItem>
              <Title>{data.produto}</Title>
              {
                usados > 0 &&   <Subtitle>{utilizadoSpan}</Subtitle>
              }
           
            </DetailItem>
          )}
        </Infos>
      </LeftContent>
    </Container>
  );
}
